//
// Automatically generated by mix operately.gen.page.index
// Do not edit this file directly
//

import AccountApiTokensPage from "./AccountApiTokensPage";
import AccountApiTokensUsagePage from "./AccountApiTokensUsagePage";
import AccountAppearancePage from "./AccountAppearancePage";
import AccountChangePasswordPage from "./AccountChangePasswordPage";
import AccountNotificationSettingsPage from "./AccountNotificationSettingsPage";
import AccountPage from "./AccountPage";
import AccountSecurityPage from "./AccountSecurityPage";
import AccountSettingsPage from "./AccountSettingsPage";
import AgentPage from "./AgentPage";
import AiPlaygroundPage from "./AiPlaygroundPage";
import CompanyAdminAddPeoplePage from "./CompanyAdminAddPeoplePage";
import CompanyAdminManageAdminsPage from "./CompanyAdminManageAdminsPage";
import CompanyAdminManagePeoplePage from "./CompanyAdminManagePeoplePage";
import CompanyAdminPage from "./CompanyAdminPage";
import CompanyAdminRestoreSuspendedPeoplePage from "./CompanyAdminRestoreSuspendedPeoplePage";
import CompanyAdminTrustedEmailDomainsPage from "./CompanyAdminTrustedEmailDomainsPage";
import CompanyExportPage from "./CompanyExportPage";
import CompanyImportPage from "./CompanyImportPage";
import CompanyManageAiAgentsPage from "./CompanyManageAiAgentsPage";
import CompanyPermissionsPage from "./CompanyPermissionsPage";
import CompanyRenamePage from "./CompanyRenamePage";
import CompanyWorkMapPage from "./CompanyWorkMapPage";
import DiscussionDraftsPage from "./DiscussionDraftsPage";
import DiscussionEditPage from "./DiscussionEditPage";
import DiscussionNewPage from "./DiscussionNewPage";
import DiscussionPage from "./DiscussionPage";
import FeedPage from "./FeedPage";
import ForgotPasswordPage from "./ForgotPasswordPage";
import GoalAccessAddPage from "./GoalAccessAddPage";
import GoalAccessManagementPage from "./GoalAccessManagementPage";
import GoalActivityPage from "./GoalActivityPage";
import GoalAddPage from "./GoalAddPage";
import GoalAsMarkdownPage from "./GoalAsMarkdownPage";
import GoalCheckInNewPage from "./GoalCheckInNewPage";
import GoalCheckInPage from "./GoalCheckInPage";
import GoalClosingPage from "./GoalClosingPage";
import GoalDiscussionEditPage from "./GoalDiscussionEditPage";
import GoalDiscussionNewPage from "./GoalDiscussionNewPage";
import GoalEditAccessLevelsPage from "./GoalEditAccessLevelsPage";
import GoalPage from "./GoalPage";
import GoalReopenPage from "./GoalReopenPage";
import HomePage from "./HomePage";
import InviteLinkJoinPage from "./InviteLinkJoinPage";
import InviteTeamPage from "./InviteTeamPage";
import JoinPage from "./JoinPage";
import LobbyPage from "./LobbyPage";
import LoginPage from "./LoginPage";
import MemberTypeSelectionPage from "./MemberTypeSelectionPage";
import MilestoneKanbanPage from "./MilestoneKanbanPage";
import MilestonePage from "./MilestonePage";
import NewCompanyPage from "./NewCompanyPage";
import NotFoundPage from "./NotFoundPage";
import NotificationsPage from "./NotificationsPage";
import PeopleOrgChartPage from "./PeopleOrgChartPage";
import PeoplePage from "./PeoplePage";
import ProfileEditPage from "./ProfileEditPage";
import ProfilePage from "./ProfilePage";
import ProjectActivityPage from "./ProjectActivityPage";
import ProjectAddPage from "./ProjectAddPage";
import ProjectAsMarkdownPage from "./ProjectAsMarkdownPage";
import ProjectCheckInEditPage from "./ProjectCheckInEditPage";
import ProjectCheckInNewPage from "./ProjectCheckInNewPage";
import ProjectCheckInPage from "./ProjectCheckInPage";
import ProjectClosePage from "./ProjectClosePage";
import ProjectContributorsAddPage from "./ProjectContributorsAddPage";
import ProjectContributorsEditPage from "./ProjectContributorsEditPage";
import ProjectContributorsPage from "./ProjectContributorsPage";
import ProjectDiscussionEditPage from "./ProjectDiscussionEditPage";
import ProjectDiscussionNewPage from "./ProjectDiscussionNewPage";
import ProjectDiscussionPage from "./ProjectDiscussionPage";
import ProjectEditAccessLevelsPage from "./ProjectEditAccessLevelsPage";
import ProjectPage from "./ProjectPage";
import ProjectPausePage from "./ProjectPausePage";
import ProjectResumePage from "./ProjectResumePage";
import ProjectRetrospectiveEditPage from "./ProjectRetrospectiveEditPage";
import ProjectRetrospectivePage from "./ProjectRetrospectivePage";
import ResetPasswordPage from "./ResetPasswordPage";
import ResourceHubDocumentPage from "./ResourceHubDocumentPage";
import ResourceHubDraftsPage from "./ResourceHubDraftsPage";
import ResourceHubEditDocumentPage from "./ResourceHubEditDocumentPage";
import ResourceHubEditFilePage from "./ResourceHubEditFilePage";
import ResourceHubEditLinkPage from "./ResourceHubEditLinkPage";
import ResourceHubFilePage from "./ResourceHubFilePage";
import ResourceHubFolderPage from "./ResourceHubFolderPage";
import ResourceHubLinkPage from "./ResourceHubLinkPage";
import ResourceHubNewDocumentPage from "./ResourceHubNewDocumentPage";
import ResourceHubNewLinkPage from "./ResourceHubNewLinkPage";
import ResourceHubPage from "./ResourceHubPage";
import ReviewPage from "./ReviewPage";
import SetupPage from "./SetupPage";
import SignUpPage from "./SignUpPage";
import SignUpWithEmailPage from "./SignUpWithEmailPage";
import SpaceAccessManagementPage from "./SpaceAccessManagementPage";
import SpaceAddMembersPage from "./SpaceAddMembersPage";
import SpaceAddPage from "./SpaceAddPage";
import SpaceDiscussionsPage from "./SpaceDiscussionsPage";
import SpaceEditGeneralAccessPage from "./SpaceEditGeneralAccessPage";
import SpaceEditPage from "./SpaceEditPage";
import SpaceKanbanPage from "./SpaceKanbanPage";
import SpacePage from "./SpacePage";
import SpaceToolsConfigurationPage from "./SpaceToolsConfigurationPage";
import SpaceWorkMapPage from "./SpaceWorkMapPage";
import TaskPage from "./TaskPage";

//
// We are explocily exporting the pages here to avoid false positives
// dead code repors form knip
//
export default {
  AccountApiTokensPage,
  AccountApiTokensUsagePage,
  AccountAppearancePage,
  AccountChangePasswordPage,
  AccountNotificationSettingsPage,
  AccountPage,
  AccountSecurityPage,
  AccountSettingsPage,
  AgentPage,
  AiPlaygroundPage,
  CompanyAdminAddPeoplePage,
  CompanyAdminManageAdminsPage,
  CompanyAdminManagePeoplePage,
  CompanyAdminPage,
  CompanyAdminRestoreSuspendedPeoplePage,
  CompanyAdminTrustedEmailDomainsPage,
  CompanyExportPage,
  CompanyImportPage,
  CompanyManageAiAgentsPage,
  CompanyPermissionsPage,
  CompanyRenamePage,
  CompanyWorkMapPage,
  DiscussionDraftsPage,
  DiscussionEditPage,
  DiscussionNewPage,
  DiscussionPage,
  FeedPage,
  ForgotPasswordPage,
  GoalAccessAddPage,
  GoalAccessManagementPage,
  GoalActivityPage,
  GoalAddPage,
  GoalAsMarkdownPage,
  GoalCheckInNewPage,
  GoalCheckInPage,
  GoalClosingPage,
  GoalDiscussionEditPage,
  GoalDiscussionNewPage,
  GoalEditAccessLevelsPage,
  GoalPage,
  GoalReopenPage,
  HomePage,
  InviteLinkJoinPage,
  InviteTeamPage,
  JoinPage,
  LobbyPage,
  LoginPage,
  MemberTypeSelectionPage,
  MilestoneKanbanPage,
  MilestonePage,
  NewCompanyPage,
  NotFoundPage,
  NotificationsPage,
  PeopleOrgChartPage,
  PeoplePage,
  ProfileEditPage,
  ProfilePage,
  ProjectActivityPage,
  ProjectAddPage,
  ProjectAsMarkdownPage,
  ProjectCheckInEditPage,
  ProjectCheckInNewPage,
  ProjectCheckInPage,
  ProjectClosePage,
  ProjectContributorsAddPage,
  ProjectContributorsEditPage,
  ProjectContributorsPage,
  ProjectDiscussionEditPage,
  ProjectDiscussionNewPage,
  ProjectDiscussionPage,
  ProjectEditAccessLevelsPage,
  ProjectPage,
  ProjectPausePage,
  ProjectResumePage,
  ProjectRetrospectiveEditPage,
  ProjectRetrospectivePage,
  ResetPasswordPage,
  ResourceHubDocumentPage,
  ResourceHubDraftsPage,
  ResourceHubEditDocumentPage,
  ResourceHubEditFilePage,
  ResourceHubEditLinkPage,
  ResourceHubFilePage,
  ResourceHubFolderPage,
  ResourceHubLinkPage,
  ResourceHubNewDocumentPage,
  ResourceHubNewLinkPage,
  ResourceHubPage,
  ReviewPage,
  SetupPage,
  SignUpPage,
  SignUpWithEmailPage,
  SpaceAccessManagementPage,
  SpaceAddMembersPage,
  SpaceAddPage,
  SpaceDiscussionsPage,
  SpaceEditGeneralAccessPage,
  SpaceEditPage,
  SpaceKanbanPage,
  SpacePage,
  SpaceToolsConfigurationPage,
  SpaceWorkMapPage,
  TaskPage,
};
